/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import { Typography } from '@zapier/design-system';

type PaymentFormFieldProps = {
  /** Children to render inside field container */
  children?: React.ReactNode;
  /** Label id */
  id?: string;
  /** Hide field */
  isHidden?: boolean;
  /** Wraps children in div instead of label, used for radio and checkbox groups */
  isGroup?: boolean;
  /** Field label */
  label?: string;
  /** Spacing for component */
  noMargin?: boolean;
  /** Number of grid columns to span */
  span?: number;
};

const styles = {
  container: (props: PaymentFormFieldProps) =>
    css(
      {
        gridColumn: props.span ? `span ${props.span}` : 'auto',
      },
      !props.noMargin && {
        marginBottom: 20,
      }
    ),
  label: (props: PaymentFormFieldProps) => ({
    ...Typography.bodyText800,
    fontWeight: 600,
    marginBottom: 10,
    display: !props.label ? 'none' : 'inherit',
  }),
};

const PaymentFormField = ({ children, ...props }: PaymentFormFieldProps) => {
  const Container = props.isGroup ? 'div' : 'label';
  return (
    <Container
      aria-label={props.id}
      css={styles.container(props)}
      hidden={props.isHidden}
      id={props.id}
    >
      <div css={styles.label(props)}>{props.label}</div>
      {children}
    </Container>
  );
};

export default PaymentFormField;
